import { styled } from '@mui/material/styles';
import { Button } from 'components/buttons';

export const AddButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`
}));
